/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { getPerformanceList } from '@/pages/dashboard/services/benchmark';

export default function SummaryService(props: any) {
  const { style, className, api, dataKey = 'summary', filterValue, data: propsData, filterLoading, gameCode, children, extraParams = {}, studioCode, latestVersionObj, ...restProps } = props || {};

  const data = useMemo(() => ({
    gameCode,
    latestVersionObj,
    ...propsData,
    ...(extraParams || {})
  }), [gameCode, extraParams,latestVersionObj, propsData]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        filterVal={filterValue}
        filterLoading={filterLoading}
        trackData={["gameCode"]}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          let versionList = [filterVal?.version?.[0]];
          // 优先取latest version没有的话则取第一个
          if (filterVal?.version?.includes(latestVersionObj?.version)) {
            versionList = [latestVersionObj.version];
          }

          const params = {
            game_code: gameCode,
            version_list: versionList,
            ...extraParams,
          };
        
          if (studioCode) {
            params.studio_code = studioCode;
          }
        
          return params;
        }}
        
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            dataKey,
            ...restProps,
          }
        ))}
      </Service>
    </div>
  );
};
